import { render, staticRenderFns } from "./ProductoTiendaConfigByProductComponent.vue?vue&type=template&id=7b2d417f&"
import script from "./ProductoTiendaConfigByProductComponent.vue?vue&type=script&lang=js&"
export * from "./ProductoTiendaConfigByProductComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports